import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Popup } from 'semantic-ui-react'

import './Details.css'

const ICON = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  FAILURE: 'failure'
}

const ACTION = {
  HOVER: 'hover',
  CLICK: 'click'
}

class Details extends React.PureComponent {

  render() {
    // Determine icon to render
    let iconName, iconColor
    const input = _.isString(this.props.icon)
      ? this.props.icon.toLowerCase()
      : this.props.icon
    switch (input) {
      case ICON.SUCCESS:
        iconName = 'checkmark'
        iconColor = 'green'
        break
      case ICON.WARNING:
        iconName = 'warning sign'
        iconColor = 'orange'
        break
      case ICON.FAILURE:
        iconName = 'warning circle'
        iconColor = 'red'
        break
      default:
        iconName = 'question circle outline'
        iconColor = 'black'
        break
    }
    const icon = (
      <Icon
        name={iconName}
        color={iconColor}
        className={ this.props.action === ACTION.CLICK ? 'cursor-pointer' : ''}
        size={this.props.big ? 'big' : undefined}
      />
    )

    // Render depends on type
    switch (this.props.action) {
      case ACTION.HOVER:
        return (
          <Popup
            trigger={icon}
            hideOnScroll={true}
            inverted={this.props.inverted ? false : true}
            on='hover'
            position='top center'
          >
            {this.props.content}
          </Popup>
        )
      case ACTION.CLICK:
        return (
          <Popup
            trigger={icon}
            hideOnScroll={false}
            inverted={this.props.inverted ? true : false}
            flowing={true}
            on='click'
            position='top center'
          >
            {this.props.content}
          </Popup>
        )
      default:
        return null
    }
  }
}

Details.propTypes = {
  icon: PropTypes.oneOf([ 'info', 'success', 'warning', 'failure' ]),
  action: PropTypes.oneOf([ 'hover', 'click' ]).isRequired,
  inverted: PropTypes.bool,
  content: PropTypes.node.isRequired,
  big: PropTypes.bool
}

Details.ICON = ICON
Details.ACTION = ACTION

export default Details



// WEBPACK FOOTER //
// ./src/components/elements/Details.js